/* eslint-disable camelcase */
import { useEffect, useState, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import useDebounce from '../../hooks/useDebounce';
import Enum from './enum';
import axiosInstance from '../../utils/axios';
import { useQueryCustom } from '../../utils/reactQueryHooks';
import RemoveNullObjectValue from '../../utils/RemoveNullObjectValue';
import RHFSelector from '../hook-form/RHFSelector';
import { fDate } from 'src/utils/formatTime';

const convertor = {
  object: (x) =>
    x && {
      label: x?.date || "",
      // <div className="flex gap-3 items-center">
      // 	<img
      // 		className="rounded-full object-cover h-[45px] w-[45px] border border-primary-main"
      // 		src={import.meta.env.VITE_IMAGE_URL + x.image?.[0]?.location}
      // 	/>

      // 	<span>{x.name}</span>
      // </div>
      value: x?.id,
      data: x,
    },
  array: (x) => (x || [])?.map(convertor.object),
};

const Element = ({ queryParams, geById,travel_id , province_id , province_name , gender, ...props }) => {
  // ----------------------------------------------------------------
  const { watch, setValue , getValues } = useFormContext();
  const watchData = watch(props.name);
  const validFetchById = !!(geById && !watchData?.value);

  const [apiParams, setApiParams] = useState({
    page: 1,
    perPage: 100,
    search: '',
    travel_id : undefined,
    province_id : undefined,
    province : undefined,
    gender : undefined,
  });

  const { debounce } = useDebounce({ setDebounce: (x) => setApiParams((p) => ({ ...p, search: x })) });
  // ----------------------------------------------------------------

  const getApi = async ({ queryKey }) => {
    const [_, params] = queryKey || [];
    if(!params?.province || !params?.travel_id){
      return () => {}
    }
    return axiosInstance.get(`${Enum?.api?.base}`, { params: RemoveNullObjectValue(params) });
  };

  const handleSuccessApi = (resData) => {
    const helpResData = resData?.data?.data;
    const findIndex = helpResData?.findIndex(item => (item?.date?.trim() === getValues(props.name) || item?.date?.trim() === getValues(props.name)?.label?.trim()))
    if(findIndex === -1){
      setValue(props.name, null);
    }
  }

  const resQuery = useQueryCustom({
    name: `gets_${Enum?.api?.base}`,
    url: getApi,
    params: apiParams,
    onSuccess:handleSuccessApi
  });

  const getByIdApi = async () => {
    return axiosInstance.get(`${Enum?.api?.base}/${geById}`);
  };
  const resByIdQuery = useQueryCustom({
    name: `get_${Enum?.api?.base}_${props.name}`,
    url: getByIdApi,
    params: apiParams,
    enabled: validFetchById,
    onSuccess: (resData) => {
      console.log('* * * citySelector getByIdApi :', { resData, geById });
      setValue(props.name, convertor.object(resData?.data));
    },
  });
  const defaultValue = validFetchById && convertor.object(resByIdQuery?.data?.data?.data);

  // ----------------------------------------------------------------

  const inputProps = {
    onChange: (e) => debounce(e.target.value),
  };

  const options = useMemo(() => {
    return convertor.array(resQuery?.data?.data?.data || []);
  }, [resQuery]);

  // ----------------------------------------------------------------

  useEffect(() => {
    if(!travel_id || !province_name) return;

    setApiParams((p) => ({ ...p, ...queryParams }));
  }, [queryParams]);

  useEffect(() => {
    if(!travel_id || !province_name) return;

    setApiParams((p) => ({ ...p, province_id : province_id }));
  }, [province_id]);

  useEffect(() => {
    if(!travel_id || !province_name) return;

    setApiParams((p) => ({ ...p, province : province_name }));
  }, [province_name]);

  useEffect(() => {
    if(!travel_id || !province_name) return;

    setApiParams((p) => ({ ...p, travel_id : travel_id }));
  }, [travel_id]);

  useEffect(() => {
    if(!travel_id || !province_name) return;

    setApiParams((p) => ({ ...p, gender : gender }));
  }, [gender]);

  useEffect(() => {
    if(!travel_id || !province_name) return;

    if (!watchData && apiParams?.search) {
      setApiParams((p) => ({ ...p, search: '' }));
    }
  }, [watchData]);
  // ----------------------------------------------------------------
  // console.log('* * * DispatchDateSelector onSuccess : ', { resQuery, options });

  // ----------------------------------------------------------------
  return (
    <RHFSelector
      defaultValue={defaultValue}
      options={options}
      inputProps={inputProps}
      loading={resQuery.isLoading}
      {...props}
    />
  );
};

const DispatchDateSelector = {
  Element,
  convertor,
};

export default DispatchDateSelector;
